import { useLocation, useNavigate } from "react-router-dom";
import AboutPutrajayaCampus from "./aboutPutrajayaCampus"
import { useEffect, useMemo, useState } from "react";
import TabHeaders from "../components/campusLife/tabHeaders";
import Contents from "../components/campusLife/tabContents";
import AboutKSHASCampus from "./aboutKSHASCampus";
import PutrajayaAccommodationMenu from "./putrajayaAccommodationMenu";
import StudentLife from "./studentLife";
import CampusServices from "./campusServices";
import { useDispatch, useSelector } from "react-redux";
import { fetchCampusLifeTabData } from "../redux/slice/campusLifeTabPage";
import { retrunAssets } from "../utils/getAssets";

const CampusLifeTabs = () => {
    const location = useLocation();
    const isKshasCampus = location.pathname.toLowerCase() === '/campus%20Life/KSHAS%20Campus'.toLowerCase();
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const defaultActiveTab = parseInt(queryParams.get('tab')) || 0;
    const state = useSelector(state => state.campusLife)
    const campusLife = state?.data?.properties
    const kshasCampus = campusLife?.unitenSultanHajiAhmadShahCampus?.route?.path
    const putrajayaCampus = campusLife?.universitiTenagaNasionalUNITEN?.route?.path


    const [activeTab, setActiveTab] = useState(defaultActiveTab);

    const handleTabClick = (index) => {
        setActiveTab(index);
        queryParams.set('tab', index);
        navigate({ search: queryParams.toString() });
    };

    useEffect(() => {
        console.log(isKshasCampus)
        if (isKshasCampus) {
            dispatch(fetchCampusLifeTabData(kshasCampus))
        } else {
            dispatch(fetchCampusLifeTabData(putrajayaCampus))
        }
    }, [dispatch, isKshasCampus, location.pathname, kshasCampus, putrajayaCampus])

    const campusTabState = useSelector(state => state.campusLifeTab)


    useEffect(() => {
        const activeTabFromQuery = parseInt(queryParams.get('tab')) || 0;
        setActiveTab(activeTabFromQuery);
    }, [queryParams]);

    const putrajayaTabs = [
        {
            header: "About Putrajaya Campus",
            content: <AboutPutrajayaCampus />
        },
         {
            header: "Student Life",
            content: <StudentLife />
        },
        {
            header: "Accommodation",
            content: <PutrajayaAccommodationMenu />
        },
        {
            header: "Campus Services & Facilities",
            content: <CampusServices />
        },
       
    ]
    const KSHASTabs = [
        {
            header: "About KSHAS Campus",
            content: <AboutKSHASCampus />
        },
        {
            header: "Accommodation",
            content: <PutrajayaAccommodationMenu />
        },
        {
            header: "Campus Services & Facilities",
            content: <CampusServices />
        },
        {
            header: "Student Life",
            content: <StudentLife />
        }
    ]
    const activeTabs = isKshasCampus ? KSHASTabs : putrajayaTabs;
    const currentTab = campusTabState?.data?.properties
    const tabBarTitle = currentTab?.tabBarTitle
    const tabBarImage = currentTab?.tabBarImage != null ? currentTab?.tabBarImage[0]?.url : ""
    return (
        <div className="w-full relative  flex flex-col ">

            <div className="w-full h-[30rem] flex relative items-end justify-center ">
                <div className="absolute inset-0 z-10 w-full h-full bg-cover  bg-center bg-no-repeat" style={{ backgroundImage: `url('${retrunAssets(tabBarImage)}')` }} >
                    <div className="absolute z-10 inset-0 bg-[rgba(0,0,0,0.3)]" /></div>
                <div className="w-full max-w-8xl flex  z-20 flex-col items-center justify-end gap-16">
                    <h1 className="text-center text-white text-4xl font-bold">{tabBarTitle}</h1>
                    <TabHeaders headers={activeTabs.map(tab => tab.header)} activeTab={activeTab} handleTabClick={handleTabClick} />
                </div>
            </div>

            <Contents contents={activeTabs.map(tab => tab.content)} activeTab={activeTab} />

        </div>
    )
}

export default CampusLifeTabs